// extracted by mini-css-extract-plugin
export default {"collectionHeading":"wy5Ft","collectionRow":"rljO5"};